/**
 * FilterBar 元件
 * 可重用的篩選器元件
 */

import type { ReactNode } from 'react';

interface FilterBarProps {
  children: ReactNode;
  className?: string;
  onClear?: () => void;
  showClearButton?: boolean;
}

export function FilterBar({
  children,
  className = '',
  onClear,
  showClearButton = false,
}: FilterBarProps) {
  return (
    <div className={`bg-white rounded-lg shadow p-4 ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-700">篩選條件</h3>
        {showClearButton && onClear && (
          <button
            onClick={onClear}
            className="text-sm text-primary hover:text-primary/80 transition-colors"
          >
            清除篩選
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {children}
      </div>
    </div>
  );
}

interface FilterItemProps {
  label: string;
  children: ReactNode;
  className?: string;
}

export function FilterItem({
  label,
  children,
  className = '',
}: FilterItemProps) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      {children}
    </div>
  );
}
